import location from '@/api/sale/location-tracking'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, data) {
    return location.get(data)
  },
  fetchNearest(context, data) {
    return location.nearest(data)
  },
  getEmployee(context) {
    return location.employee()
  },
  getUserGroup(context) {
    return location.userGroup()
  },
  getDistrict(context, params) {
    return location.district({ params })
  },
  historyVisited(context, data) {
    return location.historyVisited(data)
  },
  historyVisitedExcel(context, data) {
    return location.historyVisitedExcel(data)
  }
}
